/**
 * Quantité dynamique (lot ou étude sans lot) : multiplie proportionnellement les quantités des lignes.
 * Les prestations suivent leur quantité pour 1 unité ; forfaits, titres et lignes de dépense ne bougent pas.
 *
 * @return {Array} état d'avant le recalcul, pour l'annuler (undoScale)
 */
export function scaleLines(vm, predictions, factor) {
    var snapshot = [];
    var round = (value, decimals) => Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    var format = value => (parseFloat(value) || 0).toLocaleString('fr-FR', {maximumFractionDigits: 3});

    (predictions || []).forEach(prediction => {
        var isServiceHeader = prediction.service_block && prediction.is_title == 1;
        var isDilution = prediction.overhead_dilution_id !== null && prediction.overhead_dilution_id !== undefined && prediction.overhead_dilution_id !== '';

        vm.$delete(prediction, 'scaled_from');

        if ((prediction.is_title == 1 && !isServiceHeader) || prediction.unit === 'forfait' || isDilution) {
            return;
        }

        snapshot.push({prediction: prediction, quantity: prediction.quantity, service_quantity: prediction.service_quantity, designation: prediction.designation});

        if (prediction.service_block && parseFloat(prediction.service_quantity) > 0) {
            vm.$set(prediction, 'service_quantity', round(parseFloat(prediction.service_quantity) * factor, 3));
        }

        if (isServiceHeader) {
            prediction.designation = String(prediction.designation || '').replace(/\s*\(x[^)]*\)\s*$/, '') + ' (x' + format(prediction.service_quantity) + ')';
            return;
        }

        var previous = parseFloat(prediction.quantity) || 0;
        var unitQuantity = parseFloat(prediction.service_unit_quantity);
        prediction.quantity = prediction.service_block && !isNaN(unitQuantity)
            ? round(unitQuantity * parseFloat(prediction.service_quantity), 3)
            : round(previous * factor, 3);
        prediction.total = parseFloat(prediction.quantity) * (parseFloat(prediction.amount) || 0);
        prediction.total_selling = parseFloat(prediction.quantity) * (parseFloat(prediction.selling) || 0);
        // Repère du recalcul dans la ligne : ancienne quantité barrée et facteur
        vm.$set(prediction, 'scaled_from', previous);
        vm.$set(prediction, 'scaled_factor', factor);
    });

    return snapshot;
}

/**
 * Rétablit les quantités d'avant un recalcul
 */
export function undoScale(vm, snapshot) {
    (snapshot || []).forEach(item => {
        item.prediction.quantity = item.quantity;
        item.prediction.designation = item.designation;
        vm.$set(item.prediction, 'service_quantity', item.service_quantity);
        item.prediction.total = (parseFloat(item.prediction.quantity) || 0) * (parseFloat(item.prediction.amount) || 0);
        item.prediction.total_selling = (parseFloat(item.prediction.quantity) || 0) * (parseFloat(item.prediction.selling) || 0);
        vm.$delete(item.prediction, 'scaled_from');
        vm.$delete(item.prediction, 'scaled_factor');
    });
}

/**
 * Info-bulle du bouton calculatrice (quantité du lot ou de l'étude)
 *
 * @param {boolean} active recalcul automatique activé
 * @param {string} subject « du lot » ou « totale »
 */
export function scaleTooltip(active, subject) {
    return '<strong>Recalcul automatique ' + (active ? 'activé' : 'désactivé') + '</strong><br>'
        + (active
            ? 'En changeant la quantité ' + subject + ', les prestations et les lignes hors forfait sont multipliées proportionnellement, main d\'œuvre comprise.'
            : 'Cliquer pour recalculer les quantités des lignes (prestations et hors forfait, main d\'œuvre comprise) selon la quantité ' + subject + '.');
}
